import model from "../model";
import type { GameInfoValue } from "../types/game";
import { watch } from "vue";
import { pageReloadComplete } from "../management/user-management";

type LobbyHelperWorkflow = {
    id: number,
    featured: LobbyHelperWorkflowItem[],
    list: LobbyHelperWorkflowItem[],
};

type LobbyHelperWorkflowItem = {
    gameId?: GameInfoValue,
    gameGroup?: GameInfoValue,
};

type LobbyHelperResonse = LobbyHelperWorkflow[] | null;

let cachedData: LobbyHelperResonse = null;
let cachedDataPromise: Promise<LobbyHelperResonse> | null = null;

export default {
    init(){
        watch(() => model.userLoggedIn, () => {
            cachedData = null;
            cachedDataPromise = null;
        }, {immediate: true, flush: 'sync'});
    },
}

export async function getLobbyHelperWorkflowById(workflowId: number): Promise<LobbyHelperWorkflow | null>{
    let data = await getData();
    if(!data) return null;

    return data.find(x => x.id === workflowId) || null;
}

export async function getLobbyHelperData(){
    return await getData();
}

function getData(): Promise<LobbyHelperResonse> {
    if(cachedData) return Promise.resolve(cachedData);
    if(cachedDataPromise) return cachedDataPromise;

    const staticUrl = model.clientConfig.games?.lobbyHelper;
    if(!staticUrl) return Promise.resolve(null);

    cachedDataPromise = new Promise(resolve => {
        onRetry();
        async function onRetry(){
            let url = staticUrl;
            await pageReloadComplete();
            if(!url) {
                resolve(null);
                return;
            }
            try{
                url = url.replace('{userId}', model.userId || '0') + '?request=' + JSON.stringify({siteId: model.siteId});
                let resp = await fetch(url);
                if(!resp.ok) throw new Error('Lobby Helper response error');
                let data = await resp.json() as LobbyHelperResonse;

                data?.forEach(item => {
                    model.lobbyHelperDataExists[item.id] = item.list.length > 0 || item.featured.length > 0;
                });

                cachedData = data;
                cachedDataPromise = null;
                resolve(cachedData);
            }
            catch(e){
                console.warn("Failed to contact LobbyHelper, retrying in 3 seconds...");
                setTimeout(onRetry, 3000);
            }
        }
    });

    return cachedDataPromise;
}